import React from "react";
import cx from "classnames";
import { useSelect } from "downshift";

const Dropdown = ({ id, buttonLabel, items, onClickItem, itemsStyles='' }) => {
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps
  } = useSelect({
    id,
    items,
    selectedItem: [],
    onSelectedItemChange: ({ selectedItem }) => onClickItem(selectedItem)
  });

  const itemStyles = "dropdown-content block absolute bg-white z-50 overflow-hidden focus:outline-none " + itemsStyles

  return (
    <div className={cx("dropdown relative inline-block", { open: isOpen })}>
      <button {...getToggleButtonProps()}>{buttonLabel}</button>
      <div {...getMenuProps()} className={itemStyles}>
        {isOpen &&
          items.map((item, index) => (
            <a
              key={`${item.value}-${index}`}
              {...getItemProps({ item, index })}
              className={cx("block w-100 py-2 px-4 cursor-pointer", {
                "bg-gray-100": index === highlightedIndex
              })}
            >
              {item.label}
            </a>
          ))}
      </div>
    </div>
  );
};

export default Dropdown;
